<template>
	<div>
		<Clist :EmitSeccion="EmitSeccion" :regresar="false" @FiltrarC="Lista" :Filtro="Filtro" :Nombre="NameList" :isModal="EsModal" :Total="TotalPagina" :pConfigLoad="ConfigLoad">
			<template slot="header">
				<tr>
					<th>Nombre</th>
					<th>Correo</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,index) in Distribuidores" :key="index">
					<td>{{item.Nombre}}</td>
					<td>{{item.Candado}}</td>
					<td>
						<Cbtnaccion :pDeleteShowAll="true" :isModal="EsModal" :IrA="FormName" :pEmitSeccion="EmitSeccion" :Id="item.IdUsuario">
							<template slot="btnaccion">
								<button type="button" data-toggle="modal" data-target="#cliente" data-backdrop="static" data-keyboard="false" @click="NuevoCliente(item.IdUsuario)" v-b-tooltip.hover.top title="Asignar Clientes" class="btn-icon mr-2" ><i class="fa fa-users"></i></button>
							</template>
						</Cbtnaccion>
					</td>
				</tr>
			</template>
		</Clist>
		<Modal :Showbutton="true" :size="size" :Nombre="NameList" :poBtnSave="oBtnSave" :pEmitSeccion="EmitSeccion" :NameModal="'distribuidor'">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</Modal>
		<Modal :Showbutton="true" :size="size" :Nombre="NameListClientes" :poBtnSave="oBtnSaveCliente" :pEmitSeccion="EmitSeccionCliente" :NameModal="'cliente'">
			<template slot="Form">
				<Cliente :poBtnSave="oBtnSaveCliente"></Cliente>
			</template>
		</Modal>
	</div>
</template>

<script>
import Clist from "@/components/Clist.vue";
import Modal from "@/components/Cmodal.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros.vue";
import Form from "../Distribuidores/Form.vue";
import Cliente from "../Distribuidores/Clientes.vue";
export default {
	name:'distribuidorroot',
	components:{
		Clist,Modal,Cbtnaccion,CSinRegistros,Form,Cliente
	},
	data() {
		return {
			EmitSeccion:'distribuidor',
			EmitSeccionCliente:'cliente',
			EsModal:true,
            size:'modal-md',
            NameList:"Distribuidores",
			NameListClientes:"Clientes",
            FormName:'distribuidor',
			Pag:0,
            TotalPagina:2,
            Filtro:{
                Nombre:"",
                Placeholder:"Nombre",
                TotalItem:0,
                Pagina:1,
                Entrada:20
            },
			oBtnSave:{
                isModal:true,
                EmitSeccion:'distribuidor',
                nombreModal:'distribuidor',
                disableBtn:false,
                toast:0,
                ShowSave:true,
                ShowCancel:true
            },
			oBtnSaveCliente:{
                isModal:true,
                EmitSeccion:'cliente',
                nombreModal:'cliente',
                disableBtn:false,
                toast:0,
                ShowSave:true,
                ShowCancel:true
            },
			ConfigLoad:{
	    		ShowLoader:true,
	    		ClassLoad:true,
	    	},
			Distribuidores:[]
		}
	},
	methods: {
		async Lista(){
			this.$http.get('usuariodistribuidor/get',{
				params:{
					Nombre:this.Filtro.Nombre,
					Entrada:this.Filtro.Entrada,
					pag:this.Filtro.Pagina
				}
			}).then((res)=>{
				this.Distribuidores=res.data.data.usuarios;
				this.Filtro.Entrada	= res.data.data.pagination.PageSize;
				this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				this.Filtro.Pagina = res.data.data.pagination.CurrentPage;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		Eliminar(Id){
			this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'usuario/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    })
                }
            })
		},
		NuevoCliente(IdUsuario){
			this.bus.$emit('NewModal_'+this.EmitSeccionCliente,IdUsuario);
		}
	},
	created() {
		this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List');
		this.Lista();
		this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List',()=>
        {
            this.Lista();
        });
	},
}
</script>

<style>

</style>
